<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="16">
        <el-input v-model="topic" style="width:200px;" placeholder="型号"></el-input>
        <el-input v-model="bookName" style="width:200px;" placeholder="商品名称"></el-input>
        <el-input v-model="publisherName" style="width:200px;" placeholder="厂商名称"></el-input>
        <!-- <el-select v-model="goodsType" placeholder="商品类型" style="width:150px;">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>-->
      </el-col>
      <el-col :span="8">
        <el-button @click="handleQuery">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        :data="gridData"
        border
        highlight-current-row
        @current-change="handleCurrentChange"
        max-height="240"
      >
        <el-table-column prop="imageUrl" label="外观图片">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px" :src="scope.row.imageUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column property="title" label="商品名称" width="200"></el-table-column>
        <el-table-column property="isbn" label="商品型号" width="150"></el-table-column>
        <el-table-column property="publisher" label="厂家名称"></el-table-column>
        <el-table-column property="price" label="定价" width="150"></el-table-column>
      </el-table>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancle">取 消</el-button>
      <el-button type="primary" @click="handleOk">确认选择</el-button>
    </span>
  </div>
</template>
<script>
import { bookSelectList, bookQueryList } from "@/api/sysinfo";
export default {
  data() {
    return {
      gridData: [],
      currentRow: {},
      goodsKey: {
        1: "纸质书",
        2: "电子书",
        3: "非书籍"
      },
      topic: "",
      bookName: "",
      publisherName: "",
      goodsType: 3,
      options: [
        {
          value: 1,
          label: "纸质书"
        },
        {
          value: 2,
          label: "电子书"
        },
        {
          value: 3,
          label: "非书籍"
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    handleCancle() {
      this.$emit("close");
    },
    handleOk() {
      this.$emit("close", this.currentRow);
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    //   console.log(this.currentRow);
    },
    // 查询
    handleQuery() {
      let params = {
        goodsType: this.goodsType,
        title: this.bookName,
        publisher: this.publisherName,
        topic: this.topic
      };
      bookQueryList(params).then(data => {
        this.gridData = data.data;
      });
    },
    // 重置
    handleReset() {
      this.isbnNumber = "";
      this.bookName = "";
      this.publisherName = "";
      // this.goodsType = "";
    },
    // 获取书籍选择列表数据
    getData() {
      let params = {
        goodsType: this.goodsType
      };
      bookQueryList(params).then(data => {
        this.gridData = data.data;
      });
    },
    // 数据格式化
    formatterValue(row, col) {
      let rowValue = row.goodsType;
      return this.goodsKey[rowValue];
    }
  }
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/views/sysmanager/ClassifyInfo/components/goodsSelect.vue